<!--
 * @Author: zyb
 * @Date: 2022-03-22 19:04:12
 * @LastEditors: zyb
 * @LastEditTime: 2022-04-27 16:37:20
 * @FilePath: \dev_2.0\src\views\zh\index.vue
 * @Description: 
-->
<template>
  <div>
    <t-header @handleSubMenu="handleSubMenu" :screenWidth="screenWidth"></t-header>
    <router-view class="main" :class="{show:subMenuShow}"  :screenWidth="screenWidth"/>
    <b-footer  :screenWidth="screenWidth"></b-footer>
    <back-top></back-top>
  </div>
</template>
<script>
import THeader from "@/components/content/header/THeader.vue";
import BFooter from "@/components/content/footer/BFooter.vue";
import BackTop from "@/components/content/backTop/BackTop.vue"

export default {
  data() {
    return {
      timer:false,
      subMenuShow: false,
      screenWidth: document.body.clientWidth,
    };
  },
  components: {
    THeader,
    BFooter,
    BackTop
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {

          that.timer = false;
        }, 50);
      }
    }
  },
  methods: {
    handleSubMenu(flag) {
      this.subMenuShow = flag;
    },
    isShowShadow(flag){
      this.isShowShadowFLag = flag
    }
  },
  created(){
    
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  }
};
</script>
<style lang="scss">
.main {
  width: 100%;
  position: relative;
  transition: all 0.5s ease 0s;
  z-index: 1;
  &.show {
    height: calc(100vh - 100px);
    overflow: hidden;
    transform: translateX(-66%);
  }
}
</style>
